import { deepClone, setIn } from '../../utils/object.js'

export const Field = ({
  component: Component,
  name,
  value,
  setValue,
  ...rest
}) => (
  <Component {...{
    meta: {
      error: false,
      touched: false
    },
    input: {
      name,
      onChange: eventOrValue => {
        setValue(previousState => {
          const newState = deepClone(previousState)
          let newValue

          if (eventOrValue.target) {
            const value = eventOrValue.target.value
            newValue = eventOrValue.target.type === 'number'
              ? Number(value)
              : value
          } else {
            newValue = eventOrValue
          }

          setIn(newState, name, newValue)

          return newState
        })
      },
      value
    },
    ...rest
  }} />
)
